'use strict';
/*
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function () {

    // Load CSS
    var loadDeferredStyles = function () {
        var addStylesNode = document.getElementById("deferred-styles");
        var replacement = document.createElement("div");
        replacement.innerHTML = addStylesNode.textContent;
        document.body.appendChild(replacement)
        addStylesNode.parentElement.removeChild(addStylesNode);
    };
    var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    if (raf) raf(function () { window.setTimeout(loadDeferredStyles, 0); });
    else window.addEventListener('load', loadDeferredStyles);


    setTimeout(function () {
        svg4everybody(); // Fix SVG spritemap in IE/Edge
    });

    twentyninetimes.siteHeader.init();
    twentyninetimes.navigation.init();
    twentyninetimes.loadMore.init();
    twentyninetimes.sliders.init();
    twentyninetimes.accordion.init();
    twentyninetimes.readmore.init();
    twentyninetimes.login.init();
    twentyninetimes.form.init();
    twentyninetimes.feedback.init();
    twentyninetimes.video.init();
    twentyninetimes.itemHover.init();
    twentyninetimes.stickyNav.init();
    twentyninetimes.oembedToggle.init();
    twentyninetimes.imageOverlay.init();
    twentyninetimes.reflectiontool.init();
    twentyninetimes.subnav.init();

    var inViewItems = document.querySelectorAll('.in-view-item, .blocks-container .container-inside > *');
    if (inViewItems) {
        var test = (item) => {
            if (!item.classList.contains('elm-visible')) {
                item.classList.add('elm-visible');

                if (item.classList.contains('block-oembed--autoplay')) {
                    var playBtn = item.querySelector('.js-oembed-toggle.js-oembed-inline');
                    if (!playBtn) return;

                    playBtn.click();
                }
            }
        };
        twentyninetimes.inView.init(inViewItems, test, -100);
    }

    // Scroll functions
    window.onscroll = () => {
        // INSERT FUNCTIONS TO TRIGGER ON SCROLL

        twentyninetimes.siteHeader.checkScroll();
    };

    // Resize functions
    window.onresize = () => {
        // INSERT FUNCTIONS TO TRIGGER ON WINDOW RESIZE
    };

});


window.onload = () => {
    var hero = document.querySelector('.js-hero');

    if (hero && !hero.classList.contains('loaded')) {
        hero.classList.add('loaded');
    }
}
